import React from 'react';
import ReactDOM from 'react-dom';
import App from '../src/app/js/App';
import reportWebVitals from './reportWebVitals';
import configureStore from "./app/js/redux/Store";
import "babel-polyfill";

/**
 * Import all of the CSS files here. Styles in the CSS will have the priority in the
 * order of files imported.
 *
 */

 import "@blueprintjs/core/lib/css/blueprint.css";
 import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
 import "@blueprintjs/icons/lib/css/blueprint-icons.css";
 import "./app/styles/css/bootstrap-grid.min.css";
 import "./app/styles/css/style.scss";
 import './app/styles/css/main.scss';
 import './app/styles/css/onlineForm.scss';
 import './app/styles/css/bootstrap.min.css';
 import './app/styles/css/customHelp.css';




const store = configureStore();

ReactDOM.render(
    <App store={store} />,
  document.getElementById('root')
);

{/* <React.StrictMode>
</React.StrictMode>, */}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
